// extracted by mini-css-extract-plugin
export default {"highlight":"render_highlighted_parts-module__highlight--1PLKq"};